module.exports = __webpack_public_path__ + "static/Logo-bg-sombre-de8f40932377ebedd2088b7301d333c1.svg";